import { CircularProgress } from '@branchjs/neo-components';
import { css } from 'emotion';
import React from 'react';

const NEOCircularProgress = () => {
  const loadingStyles = css({
    position: 'relative',
    inset: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: 40,
  });
  return <CircularProgress className={loadingStyles} />;
};

export default NEOCircularProgress;
